import { InputField } from 'lib/iterable-hook-form';
import { get } from 'lodash';
import { PDFReportFormStateValues } from 'modules/messagingInsights/schema';
import { useFormContext } from 'react-hook-form';
import { FormField } from 'ui/formField';

type Props = {
  fieldName: string;
  autoFocus: boolean;
  dataTestId: string;
  fieldLabel: string;
  isHorizontalLayout?: boolean;
};

export const InputFormField = ({
  dataTestId,
  fieldName,
  fieldLabel,
  autoFocus,
  isHorizontalLayout = false,
}: Props) => {
  const {
    formState: { errors },
  } = useFormContext<PDFReportFormStateValues>();

  const errorText = get(errors, `${fieldName}.message`, '').toString();
  const hasError = !!get(errors, fieldName);

  return (
    <FormField
      data-test={dataTestId}
      labelText={fieldLabel}
      errorText={errorText}
      hasError={hasError}
      isHorizontalLayout={isHorizontalLayout}
    >
      <InputField name={fieldName} autoFocus={autoFocus} />
    </FormField>
  );
};
